import React, { useState, useEffect, useRef } from 'react';
import { ChevronUpIcon, ChevronDownIcon } from './Icons.jsx';
import './OrderQuestion.css';

function shuffledIndices(n) {
  const arr = [...Array(n).keys()];
  for (let i = arr.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  if (arr.every((v, i) => v === i) && n > 1) {
    [arr[0], arr[1]] = [arr[1], arr[0]];
  }
  return arr;
}

export default function OrderQuestion({ question, answered, onSubmit }) {
  const { payload, revealed } = question;
  const isLocked = answered || Boolean(revealed);
  const [order, setOrder] = useState(() => shuffledIndices(payload.cards.length));
  const dragFrom = useRef(null);

  useEffect(() => {
    setOrder(shuffledIndices(payload.cards.length));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [question.id]);

  const move = (pos, dir) => {
    if (isLocked) return;
    const next = [...order];
    const target = pos + dir;
    if (target < 0 || target >= next.length) return;
    [next[pos], next[target]] = [next[target], next[pos]];
    setOrder(next);
  };

  const onDrop = (pos) => {
    if (isLocked || dragFrom.current === null) return;
    const from = dragFrom.current;
    dragFrom.current = null;
    if (from === pos) return;
    const next = [...order];
    const [moved] = next.splice(from, 1);
    next.splice(pos, 0, moved);
    setOrder(next);
  };

  const submit = () => {
    if (isLocked) return;
    onSubmit({ order });
  };

  return (
    <div className="card stack">
      <div className="row-between">
        <span className="q-kicker">เรียงลำดับขั้นตอน</span>
      </div>
      <h2>{payload.instruction}</h2>

      <ol className="order-list">
        {order.map((cardIndex, pos) => (
          <li
            key={cardIndex}
            className="order-card"
            draggable={!isLocked}
            onDragStart={() => (dragFrom.current = pos)}
            onDragOver={(e) => e.preventDefault()}
            onDrop={() => onDrop(pos)}
          >
            <span className="order-index">{pos + 1}</span>
            <span className="order-text">{payload.cards[cardIndex]}</span>
            <div className="order-arrows">
              <button
                type="button"
                className="order-arrow-btn"
                disabled={isLocked || pos === 0}
                aria-label="เลื่อนขึ้น"
                onClick={() => move(pos, -1)}
              >
                <ChevronUpIcon size={14} />
              </button>
              <button
                type="button"
                className="order-arrow-btn"
                disabled={isLocked || pos === order.length - 1}
                aria-label="เลื่อนลง"
                onClick={() => move(pos, 1)}
              >
                <ChevronDownIcon size={14} />
              </button>
            </div>
          </li>
        ))}
      </ol>

      <button className="btn btn-primary btn-block" disabled={isLocked} onClick={submit}>
        {answered ? 'ส่งคำตอบแล้ว' : revealed ? 'เฉลยคำตอบแล้ว — ปิดรับคำตอบ' : 'ยืนยันลำดับ'}
      </button>
    </div>
  );
}
